// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginPage_wrapper__JzY3T","header":"LoginPage_header__pluh6","body":"LoginPage_body__fCkTn","footer":"LoginPage_footer__8YMjc","logo":"LoginPage_logo__8vDaC"};